import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import VehicleForm from "../Components/VehicleForm.js"
import Upgrade from "../Components/Upgrade.js"
import Package from "../Components/Package.js"
import CirclePlus from '../images/CirclePlus.svg'
import Modal from 'react-modal';
import AppointmentService from '../utils/AppointmentService.js';
import Sedan from '../images/spiffysedan.svg';
import NonSedan from '../images/nonsedan.svg';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class Service extends Component {
  constructor(props) {
    super(props)
    this.ApptService = new AppointmentService()
    this.state ={
      address_id:props.address_id,
      zipcode: props.zipcode,
      vehicle_type_id: 1,
      vehicle_id: props.vehicle_id,
      packages: [],
      packagesHTML: [],
      packageMenuItems: [],
      partnerPackagesHTML: [],
      partnerCode: null,
      partnerCodeEdit: '',
      partnerCodeAllowed: false,
      continueValid: false,
      recievedPackageResposnse: false,
      modalIsOpen: false,
      upgradesHTML: [],
      upgradesTotalAmount: 0,
      vehiclePackage: null,
      upgradesMap: [],
      promosAvailable: false,
      error: null,
      width: document.body.clientWidth
    }
    this.showUpgrades = this.showUpgrades.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.loadPackages()
  }

  checkCode = (code) =>
  {
    this.ApptService.check_active_promo(code)
      .then(res =>{
        if(res && res.promo){
          this.props.addEarlyPromoCode(code);
          this.setState({
            partnerCodeEdit: '',
          })
        }
        else if(res){
          this.setState({
            packagesHTML: [],
            partnerCode: code,
          })
          this.loadPackages(code);
        }
      })
      .catch(err => {
        throw new Error('Error checking promo code - ' + code + ":" + err.message);
      })
  }

  loadPackages = (partnerCode = null) => {
    var this_2 = this
    this.ApptService.packages(this.state.zipcode, this.state.vehicle_type_id, this.state.vehicle_id, this.state.address_id, partnerCode)
      .then(res =>{
        var partnerCodeExists = false
        if(res.partner_code){
          partnerCodeExists = true
          this.setState({
            partnerCode: res.partner_code
          })
        }
        this.setState({
          recievedPackageResposnse: true,
          packagesHTML: []
        })
        if(res.packages && res.packages.length > 0){
          this.props.setError("")
          this.setState({
            packages: res.packages,
            continueValid: true
          })
          var packagesHTML = []
          var count = 0
          this.state.packages.forEach(function(vehiclePackage) {
            var menu
            if( this_2.state.packageMenuItems){
              menu = this_2.state.packageMenuItems[count]
            }
            var packageAmount = vehiclePackage.amount
            var discountTotal = 0
            if(packageAmount != vehiclePackage.amount_after_promo){
              discountTotal += (parseFloat(packageAmount) - parseFloat(vehiclePackage.amount_after_promo))
              this_2.setState({
                promosAvailable:true
              })

            }
            vehiclePackage.bookedWithPartnerCode = partnerCodeExists
            this_2.props.savePromoAmount(discountTotal)
            packagesHTML.push(<Package key={count} selectedPackage = {this_2.props.selectedPackage} menu = {menu} showUpgrades={this_2.showUpgrades} vehiclePackage={vehiclePackage} /> )
            count ++;
          });
          this.setState({
            packagesHTML: packagesHTML
          })
        }
        else {
          this.setState({
            continueValid: false
          })
          if(res.partner_code){
            this.props.setError("No packages found for partner code: " + res.partner_code)}
          else{
            this.props.setError("Could not find packages. This may be caused by an invalid location or vehicle")
          }
          //throw new Error('No packages available' + res);
        }
      })
      .catch(err =>{
        throw new Error('Error retrieving packages: ' + err.message);
      })
  }

  componentDidMount() {
      window.addEventListener("resize", this.updateDimensions);

    this.ApptService.check_partner_allowed()
      .then(res =>{
        this.setState({partnerCodeAllowed: res})
      })
      .catch(err =>{
        throw new Error('Error checking partner allow: ' + err.message);
      })
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  highlightChoice = (id) => {
    Array.from(document.getElementsByClassName("package-header")).forEach(function(element, index, array) {
      element.style.backgroundColor = 'white'
    });
    if(document.getElementById("package"+ id)){
      document.getElementById("package"+ id).style.backgroundColor = "#ff8c00"
    }
  }
  showUpgrades = (vehiclePackage) => {
    this.props.selectService(vehiclePackage)
    this.highlightChoice(vehiclePackage.id)
    const upgrades = vehiclePackage.upgrades
    const this_2 = this
    var upgradesMap = this.state.upgradesMap
    var upgradesHTML = []
    upgrades.forEach(function(upgrade, index) {
      upgradesMap[upgrade.id] = upgrade
      upgradesHTML.push(<Upgrade key={index} upgrade = {upgrade} handleCheckBox={this_2.handleCheckBox}/>)
    });
    this.setState({
      upgradesMap: upgradesMap,
      vehiclePackage: vehiclePackage,
      modalIsOpen:true,
      upgradesHTML: upgradesHTML,
      upgradeIds: []
    })

  }
  componentWillMount = () => {
    this.selectedUpgradeIds = new Set();
    this.selectedUpgrades = new Set();
    this.selectedUpgradesAmounts = new Set();
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  handleCheckBox = (upgrade) => {
    upgrade = JSON.parse(upgrade)
    if (this.selectedUpgradeIds.has(upgrade.id)) {
      this.selectedUpgradeIds.delete(upgrade.id);
      this.selectedUpgrades.delete(upgrade.display_title)
      this.selectedUpgradesAmounts.delete(upgrade.amount)
    } else {
      this.selectedUpgradeIds.add(upgrade.id);
      this.selectedUpgrades.add(upgrade.display_title)
      this.selectedUpgradesAmounts.add(upgrade.amount)
    }
    var buttons = document.getElementsByClassName('submitUpgrades')
    var upgradesTotal = 0
    for (let amount of this.selectedUpgradesAmounts) {
      upgradesTotal += amount/100
    }
    this.setState({
      upgradesTotalAmount: upgradesTotal,
      upgradeIds: this.selectedUpgradeIds
    })
    var i;
    if(this.selectedUpgradeIds.size == 0){
      for (i = 0; i<buttons.length; i++){
        buttons[i].innerHTML = "Skip"
      }
    }
    else{
      for (i = 0; i<buttons.length; i++){
        buttons[i].innerHTML = "Continue"
      }
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    let trimmedCode = this.state.partnerCodeEdit.trim()
    if (!trimmedCode) {
      this.setState({
        partnerCodeEdit: trimmedCode,
      })
    } else {
      this.checkCode(trimmedCode)
    }
  }

  removePartnerCode = () => {
    this.setState({
      packagesHTML: [],
      partnerCodeEdit: '',
      partnerCode: null,
    })

    this.loadPackages('');
  }

  saveUpgrades = () => {
    this.setState({
      modalIsOpen: false
    })
    this.selectUpgrades()
  }
  selectUpgrades = () => {
    if(this.state.continueValid) {
      this.props.selectUpgrades(this.state.upgradeIds, this.state.upgradesMap, this.state.vehiclePackage)
    }
  }
  render() {
    const modalStyle =
    this.state.width < 780 ?
    {
      content: {
        top: '0%',
        left: '0%',
        right: '0%',
        backgroundColor: '#101E2C'
      }
    }:
    {
      content: {
        top: '0%',
        left: '25%',
        right: '25%',
        backgroundColor: '#101E2C'
      }
    }
    var vehiclePackage = this.state.vehiclePackage
    var packageAmount = 0
    if(vehiclePackage){
      if(vehiclePackage.amount_after_promo < vehiclePackage.amount){
        packageAmount = vehiclePackage.amount_after_promo/100
      }
      else{
        packageAmount = vehiclePackage.amount/100
      }
    }

    const customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        transform             : 'translate(-50%, -50%)'
      }
    };

    var partnerCodeInfo

    if (!this.state.recievedPackageResposnse || !this.state.partnerCodeAllowed) {
    }
    else if (this.state.partnerCode) {
      partnerCodeInfo = <div className="partner-code-display">
                          <h5>Partner Code: {this.state.partnerCode}
                            <button type="button" className="close partner-code-remove" onClick = {this.removePartnerCode}>
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </h5>
                        </div>;
    } else {
      partnerCodeInfo =
          <div style={{width: "100%"}}>
            <form className="infoForm form-inline" onSubmit={this.handleSubmit}>
              <input className="form-control partner-code" type="text" id="partnerCodeEdit" value={this.state.partnerCodeEdit}
                     onChange={this.handleChange} placeholder="Partner Code (optional)"></input>
              <button className="btn btn-primary partner-code-submit" type="submit">Lookup</button>
            </form>
          </div>;
    }

    return (
      <div>
        <div className="modal-dialog">
          <div className="modal-content">
          <div className="modal-header">
            <center><h5 className="modal-title">Service Menu</h5></center>
          </div>
          {
            this.state.promosAvailable &&
            <div className="found-codes modal-header">
              <h5 className="modal-title">You have partner Promo Codes!</h5>
            </div>
          }
            <div className="card-title" id="accordion" role="tablist">
              {this.state.packagesHTML}
            </div>
            {partnerCodeInfo}
          <div className="modal-footer bg-white">
            <button className="btn btn-outline-primary" type="button">Service Total: ${this.state.upgradesTotalAmount + packageAmount}</button>
            <button className={`btn btn-success ${this.state.continueValid ? "" : "disabled"}`} onClick = {this.selectUpgrades}>Continue</button>
          </div>
      </div>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          contentLabel="Example Modal"
          style={modalStyle}
          >
        <h3 className="whiteText"><center>Choose Your Upgrades</center></h3>
        <button id="submitUpgrades" className="btn btn-success btn-block text-center submitUpgrades" onClick={this.saveUpgrades}>Skip</button>
        <ul className="upgradesList">
        {this.state.upgradesHTML}
        </ul>
        <button id="submitUpgrades" className="btn btn-success btn-block text-center submitUpgrades" onClick={this.saveUpgrades}>Skip</button>
        </Modal>
      </div>
    )
  }
}
export default Service



// WEBPACK FOOTER //
// ./src/Components/Service.js